import React from "react";
import { useParams } from "react-router-dom";
import AdminFormalityRequest from "components/formalities/admin/AdminFormalityRequest";


export default function AdminPageFormalitiesRequest() {
  const { frId } = useParams();
  if (!frId) {
    return (
      <div className="container py-4">
        <p className="text-danger">Identifiant de demande manquant.</p>
      </div>
    );
  }
  return <AdminFormalityRequest frId={frId} />;
}
